import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ExdrLanguageService } from '../../languages/services/exdr-language.service';
import { SnackbarType } from '../enums/enums';
import { AlertComponent } from './alert.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private _matSnackBar: MatSnackBar, private langService: ExdrLanguageService) { }

  success(message: string, options?: any) {
    this.showMessage(message, options?.timeout ?? 3000, SnackbarType.Success)
  }

  error(message: string, options?: any) {
    this.showMessage(message, options?.timeout ?? 3000, SnackbarType.Error)
  }

  warn(message: string, options?: any) {
    this.showMessage(message, options?.timeout ?? 3000, SnackbarType.Warn)
  }

  dark(message: string, options?:any){
    this.showMessage(message, options?.timeout ?? 3000, SnackbarType.Dark)
  }

  private showMessage(message: string, duration: number = 3000, snackbarType: SnackbarType = SnackbarType.Success) {
    let classToApply = 'snackbar-success';
    if (snackbarType == SnackbarType.Error) {
      classToApply = 'snackbar-error';
    } else if (snackbarType == SnackbarType.Warn) {
      classToApply = 'snackbar-warn';
    } else if (snackbarType == SnackbarType.Dark) {
      classToApply = 'snackbar-dark-color';
    }
    this._matSnackBar.openFromComponent(AlertComponent, {
      data: { message, snackbarType },
      duration,
      panelClass: [classToApply],
      direction: this.langService.currentLanguage.isRtl ? 'rtl' : 'ltr',
      horizontalPosition: 'center',
      verticalPosition: 'top',

    })
  }
}
